module.exports = __webpack_public_path__ + "img/6.d34d6058.png";